import React from 'react';
import PasswordReset from './PasswordReset';
import ValidCode from './ValidCode';
import PasswordRecoveryForm from './PasswordRecoveryForm';
import { useRecoveryFlow } from '@src/features/customers/auth/password-recovery/hooks/useRecoveryFlow';
import { RECOVERY_STEP } from '@src/features/customers/types';

interface ForgotPasswordProps {
  onBack: () => void;
}

const ForgotPassword = ({ onBack }: ForgotPasswordProps) => {
  const { step, goBack } = useRecoveryFlow(onBack);

  switch (step) {
    case RECOVERY_STEP.PASSWORD_RESET:
      return <PasswordReset onBack={goBack} />;
    case RECOVERY_STEP.VALID_CODE:
      return <ValidCode onBack={goBack} />;
    case RECOVERY_STEP.PASSWORD_RECOVER:
      return <PasswordRecoveryForm onBack={goBack} />;
    default:
      return null;
  }
};

export default ForgotPassword;
